import React, { useState } from "react";
import "../../../styles/CheckoutSummary.scss";
import { getTokenOrDefault } from "../../../helpers/Storage";

interface Ticket {
  id: string;
  ticket_type: string;
  price: string;
}

interface Props {
  tickets: Ticket[];
  eventData: any;
  selectedDate?: string | null;
  selectedTime?: string | null;
  selectedTicketType?: string | null;
  selectedSeatIds?: string[];
  isSeatSection?: boolean;
   onProceed?: (
    ticketId: string,
    ticketCount: number,
    selectedDate: string | null,
    selectedTime: string | null
  ) => void;
}

const Checkout: React.FC<Props> = ({ tickets, eventData, selectedDate, selectedTime, selectedTicketType,
   selectedSeatIds = [], isSeatSection = false,     onProceed,
  }) => {
  const [quantity, setQuantity] = useState(1);
  const selectedSeats = tickets.filter((t) => selectedSeatIds.includes(t.id));
  const selectedTicket = isSeatSection
    ? selectedSeats[0]
    : tickets.find((t) => t.ticket_type === selectedTicketType);
  // const selectedTicket = tickets.find(t => t.ticket_type === selectedTicketType);
  const finalQuantity = isSeatSection ? selectedSeatIds.length : quantity;
  const price = selectedTicket ? parseFloat(selectedTicket.price) : 0;
  // const subtotal = selectedTicket ? quantity * price : 0;
   const subtotal = isSeatSection
    ? selectedSeats.reduce((sum, seat) => sum + parseFloat(seat.price), 0)
    : selectedTicket
    ? quantity * parseFloat(selectedTicket.price)
    : 0;
  const serviceFee = selectedTicket ? subtotal *  0.055 : 0;
  const totalAmount = selectedTicket ? subtotal + serviceFee : 0;
 

  const isDisabled = isSeatSection
    ? selectedSeatIds.length === 0 || !selectedDate || !selectedTime
    : !selectedTicketType || !selectedDate || !selectedTime;

  return (
    <div className="checkout-section">
      <h3>Checkout Summary</h3>

      <div className="summary">
        {/* <div className="item">
          <div>Quantity:</div>
          <div className="num qty">
            <button onClick={() => setQuantity(q => Math.max(1, q - 1))}>−</button>
            <span>{quantity}</span>
            <button onClick={() => setQuantity(q => q + 1)}>+</button>
          </div>
        </div> */}
        <div className="item">
        <div>Quantity:</div>

        {isSeatSection ? (
          <div className="num qty">
            <span>{finalQuantity}</span>
          </div>
        ) : (
          <div className="num qty">
            <button onClick={() => setQuantity((q) => Math.max(1, q - 1))}>−</button>
            <span>{quantity}</span>
            <button onClick={() => setQuantity((q) => q + 1)}>+</button>
          </div>
        )}
      </div>

        <div className="item">
          <div className="label">Subtotal:</div>
          <div className="value">₱{subtotal.toLocaleString(undefined, { minimumFractionDigits: 2 })}</div>
        </div>

        <div className="item">
          <div className="label">Convenience Fee:</div>
          <div className="value">₱{serviceFee.toLocaleString(undefined, { minimumFractionDigits: 2 })}</div>
        </div>

        <div className="item total">
          <div><strong>Total Amount:</strong></div>
          <div><strong>₱{totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</strong></div>
        </div>
      </div>

      <button
        className="checkout-btn"
        disabled={isDisabled}
         onClick={() =>
          onProceed &&
          selectedTicket &&
          onProceed(
            selectedTicket.id,
            // quantity,
            finalQuantity,
            selectedDate || null,
            selectedTime || null
          )
        }
      >
        Proceed to Checkout
      </button>
    </div>
  );
};

export default Checkout;
